import AircraftsService from "../../services/aircrafts.service";

const state = {
    aircraftList: [],
    aircraft: [],
    isActiveModal: false,
};

const mutations = {

    set_aircrafts_list(state, payload) {
        state.aircraftList = payload;
    },

    clear_aircrafts_list(state){
        state.aircraftList =[]
    },

    set_aircraft(state, payload) {
        state.aircraft = payload;
    },

    set_close_open_modal(state) {
        state.isActiveModal = !state.isActiveModal
    },

    set_clear_airport(state) {
        state.aircraft = [];
    }

};

const actions = {

    async getAircrafts({commit}) {
        await commit("clear_aircrafts_list");
        const aircrafts = await AircraftsService.GetAircraftsService();
        await commit("set_aircrafts_list", aircrafts);
        return aircrafts;
    },

    async getAircraft({commit},payload) {
        const  aircraft = await AircraftsService.GetAircraftService(payload);
        await  commit("set_aircraft",aircraft);
        return aircraft;
    },

    async UpdateAircraft({dispatch}, payload) {
        const aircraft = await AircraftsService.UpdateAircraft(payload);
        dispatch("getAircrafts");
        return aircraft
    },

    async AddAircraft({dispatch}, payload) {
        const aircraft = await AircraftsService.AddAircraft(payload);
        dispatch("getAircrafts");
        return aircraft
    },

    async deleteAircraft({dispatch}, payload) {
        const aircraft = await AircraftsService.DelAircraft(payload);
        dispatch("getAircrafts");
        return aircraft;
    },

    async openCloseAircraftModal({commit}) {
        await commit("set_close_open_modal");
        await commit("set_clear_airport");
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
